import { LoadingOutlined } from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import { h, type VNode } from 'vue'
import { v4 as uuid } from 'uuid'

export function notificationSuccess(message: string) {
  notification.success({
    class: 'ea-notification-success',
    message,
    duration: 2,
  })
}

export function notificationLoading(loadingMessage = '正在保存', successMessage = '保存成功') {
  const key = uuid()
  notification.open({
    key,
    icon: () => h(LoadingOutlined, { style: 'color: #333' }),
    message: loadingMessage,
    duration: 10,
  })
  const ret = () => {
    notification.open({
      key,
      type: 'success',
      class: 'ea-notification-success',
      message: successMessage,
      duration: 1,
    })
  }
  ret.hide = () => {
    notification.close(key)
  }
  return ret
}

export function notificationWarn(message: string) {
  notification.warn({
    message,
    duration: 3,
  })
}

export function notificationError(message: string | VNode) {
  notification.error({
    class: 'ea-notification-error',
    message,
    duration: 30,
  })
}
